export default __webpack_public_path__ + "static/media/testimonial_1.3e449c38.jpg";